import { render, staticRenderFns } from "./WorkAssignmentCostCodeEdit.vue?vue&type=template&id=2c2cc3e2&scoped=true"
import script from "./WorkAssignmentCostCodeEdit.vue?vue&type=script&lang=js"
export * from "./WorkAssignmentCostCodeEdit.vue?vue&type=script&lang=js"
import style0 from "./WorkAssignmentCostCodeEdit.vue?vue&type=style&index=0&id=2c2cc3e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2cc3e2",
  null
  
)

export default component.exports